module.exports = __webpack_public_path__ + "assets/img/header-icon.c0ac9090.png";